import Section from 'scripts/core/section';
import { CampaignsPageSections, FaqsPageSections, HomePageSections, FulfillmentPageSections, PrivacyPageSections } from 'common/views/sectionTypes';
import gsap from 'gsap';
import { createScrollTrigger } from 'scripts/lib/gsap/scrollTrigger';
import { HeaderColorClass, ChangeColorHeaderConfig, setupTriggerChangeColorHeader } from 'scripts/modules/changeColor';
import { JoinUsThreeAnimationBridge } from './animation/bridge';
import { Breakpoints } from 'common/views/appBreakpoints';
import { setupSection } from 'scripts/utils/setupComponents';

export default class JoinSection extends Section {

    private get _title() { return this.element.querySelector('.join-section__title'); }


    async setupSection() {

        if (Breakpoints.isDesktop) {
            this.setupTitleAnimation();
        }
        this.setupChangeHeaderColor();
    }

    private setupTitleAnimation = () => {
        const timelineScroll = gsap.timeline()
            .to(this._title, { scale: 0.5, transformOrigin: 'center bottom' });

        createScrollTrigger({
            trigger: this.element,
            start: 'top top',
            end: 'bottom+=10% bottom',
            scrub: 1,
            animation: timelineScroll,
        });
    };


    private setupChangeHeaderColor = () => {

        const colorConfigViolet: ChangeColorHeaderConfig = {
            element: this.element,
            color: HeaderColorClass.Violet,
            triggerVars: {
                start: 'top top',
                end: 'bottom top',
            },
        };

        setupTriggerChangeColorHeader(colorConfigViolet);
    };

    protected _activate(): void | Promise<void> {
        JoinUsThreeAnimationBridge.isActive.setTrue();
    }

    protected _deactivate(): void | Promise<void> {
        JoinUsThreeAnimationBridge.isActive.setFalse();
    }

}

const currentId = document.getElementById(HomePageSections.Join)?.id || document.getElementById(CampaignsPageSections.Join)?.id || document.getElementById(FaqsPageSections.Join)?.id || document.getElementById(FulfillmentPageSections.Join)?.id || document.getElementById(PrivacyPageSections.Join)?.id;

setupSection(JoinSection, { id: currentId });
